import { Injectable } from '@angular/core';
import cryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  deleteAllData(): void {
    localStorage.clear();
  }

  getData(item: string): any {
    if (typeof localStorage !== 'undefined') {
      const encodeData = localStorage.getItem(item);
      if (encodeData) {
        const decodeData = cryptoJS.AES.decrypt(encodeData, 'encoded data from AnTim GPS').toString(cryptoJS.enc.Utf8);
        return decodeData;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  setData(item: string, values: any): void {
    const cryptoData: any = cryptoJS.AES.encrypt(values.toString(), 'encoded data from AnTim GPS');
    localStorage.setItem(item, cryptoData);
  }

  deleteData(item: string): void {
    localStorage.removeItem(item);
  }

  getLoginData(): any {
    const loginData = this.getData('loginData');
    if (loginData) {
      try {
        return JSON.parse(loginData);
      } catch (error) {
        console.error('Failed to parse login data:', error);
        return null;
      }
    }
    return null;
  }

}
